module.exports = __webpack_public_path__ + "static/media/2.878c4577.png";